export default __webpack_public_path__ + "static/media/resource-other-featured-image-placeholder.a65173f1.svg";